<script>
import { mapState } from 'vuex';

  export default{
    props: {
      title: {type: String, default: ''},
      active: {type: Boolean, default: false}
    },
    computed: {
      ...mapState(['client'])
    }
  }
</script>
<style lang="sass">
.pfslide
  display: flex
  flex-direction: column
  align-items: center
  transition: opacity .6s ease
  //overflow: hidden
  &-newred
    color: colors.$newred
  &:not(.active)
    height: 0
    pointer-events: none
    opacity: 0
    &:not(.slide_notinited)
      >*
        display: none !important
  &__1028wrap
    width: 100%
    max-width: 1028px
    margin: 0 auto
  &__map
    width: 100%
    height: 140px
    margin-bottom: 32px
    @include for-mob
      display: none
    #map
      width: 100%
      height: 100%
  &__thincontent
    width: 604px
    max-width: 100%
    display: flex
    flex-direction: column
    align-items: center
    >.aoformlabel:last-child
      margin-bottom: 32px
    &_sl0
      margin-bottom: 10px
      @include for-mob
        margin-bottom: 2px
  &__title
    letter-spacing: globalvars.$onespacing
    text-align: center
    font-weight: 500
    font-size: 36px
    line-height: 1.1
    color: colors.$bluefont
    margin-top: 29px
    margin-bottom: 60px
    &_smspace
      margin-bottom: 16px
    @include for-mob
      font-size: 28px
      line-height: 1.1
      margin-top: 28px
      margin-bottom: 61px
      &_smspace
        margin-bottom: 16px
  &__smtitle
    letter-spacing: globalvars.$onespacing
    text-align: center
    font-weight: 400
    font-size: 24px
    line-height: 1.16
    color: colors.$bluefont2
    margin-bottom: 60px
    margin-top: 8px
    b
      font-weight: 500
      font-size: 28px
      line-height: 1.14
    &_smspace
      margin-bottom: 31px
    &_microspace
      margin-bottom: 16px
    @include for-mob
      font-size: 20px
      margin-top: 0
      margin-bottom: 60px
      &_smspace
        margin-bottom: 16px


  &__subtitle
    width: 100%
    margin-top: 40px
    margin-bottom: 24px
    font-weight: 500
    font-size: 20px
    line-height: 32px
    &_center
      text-align: center
    &_smspace
      margin-top: 8px
    @include for-mob
      margin-top: 32px
      &_smspace
        margin-top: 8px

  &__cardgrid
    width: 100%
    padding: 16px 0
    display: grid
    grid-gap: 32px
    gap: 32px
    grid-template-columns: 1fr 1fr

    @include for-mob
      grid-template-columns: 1fr
      grid-gap: 24px
      gap: 24px
    &_afterspace
      margin-bottom: 16px
      @include for-mob
        margin-bottom: 8px
</style>